import { render, staticRenderFns } from "./DoctorDs.vue?vue&type=template&id=736e1fa3&scoped=true"
import script from "./DoctorDs.vue?vue&type=script&lang=js"
export * from "./DoctorDs.vue?vue&type=script&lang=js"
import style0 from "./DoctorDs.vue?vue&type=style&index=0&id=736e1fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e1fa3",
  null
  
)

export default component.exports